import { Dropdown } from "react-bootstrap";
import { useThemeContext } from "../../../../../theme/ThemeContext";
import { Theme } from "../../../../../../constant/Theme";
import StyledToggle from "../../../../../boundarySelection/ViewTools/StyledToggle";
import useGetOrderItemInrixVolumeParams, {
  InrixVolumeDayOfWeek,
  InrixVolumeTimePeriod,
} from "./GetOrderItemInrixVolumeParams";

const dayOptions: { value: InrixVolumeDayOfWeek; label: string }[] = [
  { value: InrixVolumeDayOfWeek.SUNDAY, label: "Sunday" },
  { value: InrixVolumeDayOfWeek.MONDAY, label: "Monday" },
  { value: InrixVolumeDayOfWeek.TUESDAY, label: "Tuesday" },
  { value: InrixVolumeDayOfWeek.WEDNESDAY, label: "Wednesday" },
  { value: InrixVolumeDayOfWeek.THURSDAY, label: "Thursday" },
  { value: InrixVolumeDayOfWeek.FRIDAY, label: "Friday" },
  { value: InrixVolumeDayOfWeek.SATURDAY, label: "Saturday" },
];

const OrderItemInrixVolumeDayDropdown = () => {
  const { theme } = useThemeContext();
  const { timePeriod, dayOfWeek, handleSelectDayOfWeek } =
    useGetOrderItemInrixVolumeParams();

  if (timePeriod !== InrixVolumeTimePeriod.FIFTEEN_MINS) {
    return null;
  }

  const selectedLabel =
    dayOptions.find((day) => day.value === dayOfWeek)?.label ??
    "Select day of week";

  const handleSelect = (selectedDay: string | null) => {
    if (
      selectedDay === InrixVolumeDayOfWeek.MONDAY ||
      selectedDay === InrixVolumeDayOfWeek.TUESDAY ||
      selectedDay === InrixVolumeDayOfWeek.WEDNESDAY ||
      selectedDay === InrixVolumeDayOfWeek.THURSDAY ||
      selectedDay === InrixVolumeDayOfWeek.FRIDAY ||
      selectedDay === InrixVolumeDayOfWeek.SATURDAY ||
      selectedDay === InrixVolumeDayOfWeek.SUNDAY
    ) {
      handleSelectDayOfWeek(selectedDay);
    }
  };

  return (
    <Dropdown onSelect={handleSelect}>
      <StyledToggle
        className={`view-tools-dropdown fs-6 ${theme === Theme.DARK ? "text-white" : "text-black"}`}
        size="lg"
      >
        <span className="toggle-text">{selectedLabel}</span>
      </StyledToggle>
      <Dropdown.Menu className="w-100 fs-6">
        {dayOptions.map((day) => (
          <Dropdown.Item
            key={day.value}
            eventKey={day.value}
            active={day.value === dayOfWeek}
            className={day.value === dayOfWeek ? "bg-primary text-white" : undefined}
          >
            {day.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default OrderItemInrixVolumeDayDropdown;
